import { render, staticRenderFns } from "./ProjectTaskTemplateNewForm.vue?vue&type=template&id=d619ff52"
import script from "./ProjectTaskTemplateNewForm.vue?vue&type=script&lang=js"
export * from "./ProjectTaskTemplateNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports